module.exports = __webpack_public_path__ + "img/icon-form.62aa0060.png";